import type { RouteGuideLoadStatus } from '@fv/models'

import InfoBox from '@/components/InfoBox'

type Props = {
  status?: RouteGuideLoadStatus
  className?: string
}

export const RouteGuideEmptyState = ({ status, className }: Props) =>
  status === 'pending' ? (
    <InfoBox icon="spinner" className={className}>
      Building the contracted carrier list for this shipment…
    </InfoBox>
  ) : (
    <InfoBox icon="ban" className={className}>
      This shipment has no active contracted rates to tender against.
    </InfoBox>
  )
